export default "__VITE_ASSET__BCWAZ8jj__"